import {NonActionableError} from '@freckle/student-entities/ts/common/helpers/ajax/helpers/errors/base/non-actionable-error'
import {logErrorAsUnhandled} from '../../common/helpers/exception-handlers/bugsnag-client'

export const reportActionableError = (error: unknown) => {
  if (error instanceof Error && error instanceof NonActionableError === false) {
    logErrorAsUnhandled(error)
  }
}
